<template>
  <BaseCardBody>
    <h3 class="text-base font-medium mb-4">
      {{ $t('importContactsModal.parseSection.title') }}
    </h3>
    <FileUpload
      :options="{
        allowMultiple: false,
        acceptedFileTypes:
          'text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        labelIdle: `${$t(
          'importContactsModal.parseSection.uploadLabel1'
        )} <span class=\'underline cursor-pointer\'>${$t(
          'importContactsModal.parseSection.uploadLabel2'
        )}</span> ${$t('importContactsModal.parseSection.uploadLabel3')}`,
      }"
      v-model="media"
    />
    <BaseVeeForm :action="parseCsv">
      <template #default="formProps">
        <div class="space-y-8">
          <ValidationProvider name="file" slim vid="upload_id" rules="required">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormInput type="hidden" :value="uploadId" />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
          <ValidationProvider
            name="has heading"
            slim
            vid="has_headings"
            :rules="{ required: false }"
          >
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormCheckbox
                  v-model="hasHeadings"
                  :label="$t('importContactsModal.parseSection.hasHeadings')"
                />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
          <BaseButton primary :disabled="formProps.ivalid">
            {{ $t('importContactsModal.parseSection.submit') }}
          </BaseButton>
        </div>
      </template>
    </BaseVeeForm>
  </BaseCardBody>
</template>
<script>
import FileUpload from 'Components/FileUpload/Index.vue';
import { importContactsClient } from '@/api/clients';

export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      media: [],
      hasHeadings: true,
    };
  },
  computed: {
    uploadId() {
      return this.media?.[0]?.modelId || '';
    },
  },
  methods: {
    parseCsv() {
      return importContactsClient
        .parse({
          upload_id: this.uploadId,
          has_headings: this.hasHeadings,
        })
        .then((response) => {
          this.parseData = response;
          this.$emit('parsed', {
            uploadId: this.uploadId,
            data: response,
          });
          return Promise.resolve();
        });
    },
  },
};
</script>
